import { useState } from "react"
import { useTranslation } from "react-i18next"
import { renderMessageLines } from "@/modules/chats/components/chat-message/render-message-lines"

export const NonAutoTranslatedAgentMessageContent = (props: {
  deliveredContent: string
  originalMessageContent: string
  hasAiGeneratedContent: boolean
}) => {
  const { t } = useTranslation()
  const [isShowOriginalMessage, setIsShowOriginalMessage] = useState(false)

  const displayedContent = isShowOriginalMessage ? props.originalMessageContent : props.deliveredContent

  return (
    <div className="grid h-fit gap-1 text-sm" data-testid="chat-message-from-agent">
      {renderMessageLines(displayedContent)}
      {props.originalMessageContent && props.hasAiGeneratedContent && (
        <button
          className="text-on-primary cursor-pointer text-left text-xs hover:underline"
          onClick={() => setIsShowOriginalMessage((previous) => !previous)}>
          {isShowOriginalMessage ? t("chat.see.delivered") : t("chat.see.original")}
        </button>
      )}
    </div>
  )
}
